import React from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from "@material-ui/core/Paper"
import { withStyles } from '@material-ui/core/styles';
import {PopoverComponent} from '@components/form/PopoverComponent';
import InputAdornment from '@material-ui/core/InputAdornment';

const styles = {
    root: {
      // padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: "100%",
    },
  };

function InputComponent (props) {
    let {classes, name, value, errors = [], errorSubKey = '', children, ...other} = props;
    let errorField = (errors[name] || errors[errorSubKey + '.' + name] || undefined);
    let errorText = errorField ? errorField.join('. ') : undefined;

    return (
        <Paper className={classes.root} style={{backgroundColor: props.customBgColor || 'transparent'}} elevation={0}>
            <TextField
                // defaultValue={value}
                value={value !== null ? value : ''}
                id={name}
                name={name}
                error={!!errorField}
                helperText={errorText}
                {...other}
                inputProps={{
                    ...props.inputProps,
                    autoComplete: 'new-password',
                }}
            >
                {children}
            </TextField>
            {props.popover && (
                <PopoverComponent
                    text={props.popover}
                />
            )}
        </Paper>
    )
};

export const Input = withStyles(styles)(InputComponent);
